import script from "./GiftPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftPage.vue?vue&type=script&setup=true&lang=js"

import "./GiftPage.vue?vue&type=style&index=0&id=71ea1ba6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ea1ba6"]])

export default __exports__